// Import polyfills first
import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const auth0Optional = process.env.REACT_APP_AUTH0_OPTIONAL === 'true';

// In dev-optional mode (no real Auth0 creds), skip the provider entirely.
// The app will run as an anonymous dev user.
const auth0Ready =
  domain &&
  clientId &&
  !domain.startsWith('your-domain') &&
  !clientId.startsWith('your-client');

if (!auth0Ready && !auth0Optional) {
  console.error('Auth0 configuration missing. Please check your .env file.');
  throw new Error('Auth0 domain and client ID must be set in .env file');
}

if (!auth0Ready) {
  console.warn('[dev] Auth0 not configured — running in unauthenticated dev mode.');
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
const root = ReactDOM.createRoot(rootElement);

// Wrap with Auth0Provider only when we have real credentials.
const tree = auth0Ready ? (
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{ redirect_uri: window.location.origin, audience }}
  >
    <App devMode={false} />
  </Auth0Provider>
) : (
  <App devMode={true} />
);

root.render(<React.StrictMode>{tree}</React.StrictMode>);
